<template>

  <div class="vflex">
    <!-- the filters have no room in the slim column -->
    <ConversationFilters
      v-if="!slim"
      class="p-3"
      :filters="filters"
      :facets="facets"
      :search="search"
      @update:filters="$emit('update:filters', $event)"
      @update:search="$emit('update:search', $event)" />

    <ConversationList
      :slim="slim"
      :conversations="conversations"
      :loading="loading"
      :loading-more="loadingMore"
      :has-more="hasMore"
      :selected-id="selectedId"
      @select="$emit('select', $event)"
      @load-more="$emit('load-more')" />

    <!-- new contact: only the icon fits the slim column -->
    <div
      class="border-top"
      :class="slim ? 'p-2' : 'p-3'">
      <button
        type="button"
        class="btn btn-primary btn-block"
        :title="$t('Add contact')"
        @click="$emit('new-conversation')">
        <i
          class="fa-solid fa-plus"
          :class="{ 'mr-1': !slim }"></i>
        <template v-if="!slim">{{ $t('Add contact') }}</template>
      </button>
    </div>

  </div>

</template>

<script>
import ConversationFilters from './ConversationFilters.vue'
import ConversationList from './ConversationList.vue'

export default {
  name: 'ConversationSidebar',
  components: {
    ConversationFilters,
    ConversationList
  },
  props: {
    conversations: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    },
    loadingMore: {
      type: Boolean,
      default: false
    },
    hasMore: {
      type: Boolean,
      default: false
    },
    selectedId: {
      type: String,
      default: null
    },
    filters: {
      type: Object,
      default: () => ({ assigned: 'all', agent: 'any', unreplied: false })
    },
    facets: {
      type: Object,
      default: () => ({})
    },
    search: {
      type: String,
      default: ''
    },
    // narrow column: numbered circles, no filters and no button label
    slim: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Messaging/sidebar/ConversationSidebar.vue